import React from 'react';

const ErrorContent: React.FC = () => {
  return (
    <div className="layout-section confirmation-block b-padding-inline--micro--jumbo">
      <label className="b-typography-sans-serif--headline--200 b-font-weight-bold">
        Error: Unable to complete the process.
      </label>
    </div>
  );
};

export default ErrorContent;
